import React, {useState} from 'react'
import Modal from "react-bootstrap/Modal"
import Button from "react-bootstrap/Button"
import {FaSave} from 'react-icons/fa'
import DrivePropertiesCard from "../elements/DrivePropertiesCard"
import FolderPropertiesCard from "../elements/FolderPropertiesCard"
import RenameCard from "../elements/DriveRenameCard"
import {useNavigate} from 'react-router-dom'
import {getLocalStorageItem, getPathBack, setErrorWindow, setLocalStorageItem} from "../functions"
import LinkPropertiesCard from "../elements/LinkPropertiesCard"
import {ViewWindowQuestion} from "../elements/ViewWindowQuestion"
import GoogleUploadCard from "../elements/GoogleUploadCard"
import CloudinaryUploadCard from "../elements/CloudinaryUploadCard";

export const WindowPopup = ({
                                lang,
                                data,
                                onRename,
                                title = '',
                                btnOKText = 'OK',
                                btnCancelText = 'Cancel',
                                isBtnOk = 'd-none',
                                isBtnCancel = 'd-none',
                                btnOKVariant = 'success',
                                btnCancelVariant = 'secondary',
                            }) => {

    const [show, setShow] = useState(true)
    const [dataModal, setDataModal] = useState({})
    const [isQuestion, setIsQuestion] = useState(true)
    const navigate = useNavigate()

    if (!data) return null

    const closeHandler = () => {
        if (document.querySelector('#btn-save') && !document.querySelector('#btn-save').disabled) {
            let update = '', title = '', clickCancel = `replaceTo ${getPathBack()}`
            if (data.typeData === 'link-properties') {
                title = lang.body.linkPage.windowRequestIfSave.titleUpdate
                update = 'updateLink'
                clickCancel = `replaceTo /${lang.lang}/folder/open/${data.link.parentFolder}` || `replaceTo ${getPathBack()}`
            }
            if (data.typeData === 'folder-properties') {
                title = lang.body.folderPage.windowRequestIfSave.titleUpdate
                update = 'updateFolder'
                clickCancel = `replaceTo /${lang.lang}/folder/open/${data.folder.parentFolder}` || `replaceTo ${getPathBack()}`
            }
            setIsQuestion(false)
            setDataModal(
                setErrorWindow(
                    title,
                    '',
                    lang.body.linkPage.windowRequestIfSave.descriptionUpdate,
                    lang.body.linkPage.windowRequestIfSave.btnOKUpdate,
                    update,
                    lang.body.linkPage.windowRequestIfSave.btnCancelUpdate,
                    clickCancel,
                    'success',
                    'danger'))

        } else {
            setShow(false)
            if (data.folder && data.folder.parentFolder) {
                navigate(`/${lang.lang}/folder/open/${data.folder.parentFolder}`, {replace: true})
            } else if (data.link && data.link.parentFolder) {
                navigate(`/${lang.lang}/folder/open/${data.link.parentFolder}`, {replace: true})
            } else {
                navigate(getPathBack(), {replace: true})
            }
        }
    }

    const clickHandler = (pathStr) => {
        if (!pathStr) {
            navigate(`/${lang.lang}/`, {replace: true})
        }
        navigate(`/${lang.lang}/${pathStr}`, {replace: true})
    }

    if (data.typeData === 'link-properties') {
        setLocalStorageItem('link-properties-data', {
            _id: data.link._id,
            name: data.link.name,
            desc: data.link.description,
            login: data.link.login,
            pass: data.link.password,
            from: data.link.from,
        })
    }
    if (data.typeData === 'folder-properties') {
        setLocalStorageItem('folder-properties-data', {
            _id: data.folder._id,
            name: data.folder.name,
            desc: data.folder.description,
            owner: data.folder.owner
        })
    }

    if (!isQuestion) {
        if (data.typeData === 'link-properties') {
            setLocalStorageItem('link-properties-data', {
                _id: data.link._id || '',
                name: document.querySelector('#name')?.value,
                desc: document.querySelector('#description')?.value,
                login: document.querySelector('#login')?.value,
                pass: document.querySelector('#password')?.value,
                from: document.querySelector('#from')?.value,
            })
            return (
                <>
                    {<ViewWindowQuestion object={getLocalStorageItem('link-properties-data')} data={dataModal}/>}
                </>
            )
        }
        if (data.typeData === 'folder-properties') {
            setLocalStorageItem('folder-properties-data', {
                _id: data.folder._id || '',
                name: document.querySelector('#name')?.value,
                desc: document.querySelector('#description')?.value,
                owner: data.folder.owner
            })
            return (
                <>
                    {<ViewWindowQuestion object={getLocalStorageItem('folder-properties-data')} data={dataModal}/>}
                </>
            )
        }
    }

    return (
        <>
            <Modal id={'popup'} show={show}>
                <Modal.Header>
                    <Modal.Title className={'w-100'}>{title}</Modal.Title>
                    <div className={"d-flex justify-content-end gap-2 align-items-center"}>

                        {/* Кнопка Save */}
                        {(data.typeData === 'folder-properties' || data.typeData === 'link-properties') &&
                        <Button id={'btn-save'}
                                className={"d-flex align-items-center d-none"}
                                variant={"success"}
                                disabled={true}>
                            <FaSave className={'fs-3'}/>
                        </Button>}

                        {/* Кнопка Close */}
                        <Button
                            variant={'close'}
                            onClick={closeHandler}
                        />
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <h3 className={'text-center'}>{data.name}</h3>
                    {data.typeData === 'google-properties' && <DrivePropertiesCard fileData={data} lang={lang}/>}
                    {data.typeData === 'folder-properties' && <FolderPropertiesCard folderData={data} lang={lang}/>}
                    {data.typeData === 'link-properties' && <LinkPropertiesCard data={data} lang={lang}/>}
                    {/*{data.typeData === 'note-properties' && <NotePropertiesCard data={data} lang={lang}/>}*/}
                    {data.typeData === 'google-rename' && <RenameCard data={data} lang={lang} onRename={onRename}/>}
                    {data.typeData === 'folder-rename' && <RenameCard data={data} lang={lang} onRename={onRename}/>}
                    {data.typeData === 'link-rename' && <RenameCard data={data} lang={lang} onRename={onRename}/>}
                    {data.typeData === 'note-rename' && <RenameCard data={data} lang={lang} onRename={onRename}/>}
                    {data.typeData === 'google-upload-file' && <GoogleUploadCard data={data} lang={lang} />}
                    {data.typeData === 'cloudinary-upload-image' && <CloudinaryUploadCard data={data} lang={lang} />}
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant={btnOKVariant}
                        className={isBtnOk}
                        onClick={() => {
                            clickHandler(data.clickOK)
                        }}>
                        {btnOKText}
                    </Button>
                    <Button
                        variant={btnCancelVariant}
                        className={isBtnCancel}
                        onClick={() => {
                            clickHandler(data.clickCancel)
                        }}>
                        {btnCancelText}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}